import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import styled from '@emotion/styled';

import Button from 'Components/LegacyButton';
import TextImage from 'Components/TextImage';
import { palette } from 'Components/ThemeProvider';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

const LogosContainer = styled.div`
  display: flex;
  margin-top: 42px;
  margin-left: -20px;
`;
const Logo = styled.img`
  width: 98px;
`;
const StyledButton = styled(Button)`
  max-width: 290px;
  width: 100%;
`;
const Sustainability = ({
  content: { title, description, cta, imageDesktop, imageMobile, imageAlt, logos },
  backgroundColor,
  dataTestId,
  imageMode,
  TitleProps,
}) => {
  return (
    <TextImage
      backgroundColor={backgroundColor}
      contentAlign="left"
      contentAlignMob="left"
      dataTestId={dataTestId}
      description={description}
      DescriptionProps={{ color: 'noir' }}
      hasMiddleBorder
      imageAlt={imageAlt}
      imageDesktop={imageDesktop}
      imageMobile={imageMobile}
      imageMode={imageMode}
      title={title}
      TitleProps={TitleProps}
    >
      {cta && (
        <StyledButton
          Component={Link}
          data-click={cta.dataClick}
          data-from={cta.dataFrom}
          to={cta.path}
          variant="noir"
        >
          {cta.label}
        </StyledButton>
      )}
      <LogosContainer>
        <Logo alt="logo-bcorp" src={logos.bCorp.src} />
        <Logo alt="logo-climate" src={logos.climate.src} />
      </LogosContainer>
    </TextImage>
  );
};

Sustainability.propTypes = {
  TitleProps: PropTypes.shape({
    variant: PropTypes.string,
  }),
  backgroundColor: PropTypes.string,
  dataTestId: PropTypes.string,
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired,
    cta: PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      dataClick: PropTypes.string.isRequired,
      dataFrom: PropTypes.string.isRequired,
    }),
    imageDesktop: srcOrNextImageProp.isRequired,
    imageMobile: srcOrNextImageProp.isRequired,
    logos: PropTypes.shape({
      bCorp: srcOrNextImageProp.isRequired,
      climate: srcOrNextImageProp.isRequired,
    }).isRequired,
    imageAlt: PropTypes.string.isRequired,
  }).isRequired,
  imageMode: PropTypes.oneOf(['cover', 'contain', 'contain-desktop']),
};

Sustainability.defaultProps = {
  TitleProps: { variant: 'h1r' },
  backgroundColor: palette.white.light,
  dataTestId: null,
  imageMode: 'cover',
};

export default Sustainability;
